import { BrowserRouter } from "react-router-dom";
import NavigationScroll from "./layout/MainLayout/NavigationScroll";
import Routes from "./routes";
import ThemeContextProvider from "./theme/ThemeContext";
import { HelmetProvider } from "react-helmet-async";
function App() {
  return (
    <BrowserRouter>
      <ThemeContextProvider>
        <NavigationScroll>
          <HelmetProvider>
            <Routes />
          </HelmetProvider>
        </NavigationScroll>
      </ThemeContextProvider>
    </BrowserRouter>
  );
}

export default App;
